import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTriangleExclamation, FaArrowsRotate } from 'react-icons/fa6';

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

/**
 * ErrorState sub-component
 * Shows error message with retry button
 */
export const ErrorState: React.FC<ErrorStateProps> = memo(({ error, onRetry }) => {
  const { t } = useTranslation('training');

  return (
    <div className="mt-6 sm:mt-8 rounded-xl border border-red-200/60 bg-card overflow-hidden shadow-sm">
      <div className="flex flex-col items-center justify-center py-14 sm:py-18 px-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-red-700 mb-4">
          <FaTriangleExclamation className="text-white text-base" />
        </div>
        <h3 className="text-sm sm:text-base font-semibold text-foreground mb-1.5 tracking-tight">
          {t('training.visualization.error')}
        </h3>
        <p className="text-xs sm:text-sm text-muted-foreground mb-5 text-center max-w-sm leading-relaxed">{error}</p>
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 px-4 py-2 text-xs sm:text-sm font-medium text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 active:scale-[0.98] transition-all duration-150"
        >
          <FaArrowsRotate className="text-[10px]" />
          {t('training.visualization.retry')}
        </button>
      </div>
    </div>
  );
});

ErrorState.displayName = 'ErrorState';

export default ErrorState;
